import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const {
  DOMAINS,
  QUESTIONS,
  USER,
  OTP,
  REQUEST_STATE_QUESTION,
  REQUEST_STATE_OTP,
  TOKEN_TMP,
  PASSW_POLICY,
  RETRYS,
  GENERATE_OTP_CALL_STATE,
  GENERATE_OTP_RECEIVER,
  FIRST_ACCESS,
  OLD_PASSWORD,
} = STATE_IDENTIFIER;

const emptyState = {
  [DOMAINS]: [],
  [QUESTIONS]: [],
  [USER]: "",
  [OTP]: "",
  [REQUEST_STATE_QUESTION]: IResponseState.PENDING,
  [REQUEST_STATE_OTP]: IResponseState.PENDING,
  [TOKEN_TMP]: "",
  [PASSW_POLICY]: {},
  [RETRYS]: 3,
  [GENERATE_OTP_CALL_STATE]: IResponseState.PENDING,
  [GENERATE_OTP_RECEIVER]: null,
  [FIRST_ACCESS]: false,
  [OLD_PASSWORD]: null,
};

export default emptyState;
